import { LicensesByType } from './types';
import _ from 'lodash';

export const groupLicensesByType = <T extends { license: string }>(content?: T[]): LicensesByType<T> => {
    return _.groupBy(content, 'license');
};

export const getLicenseKey = (licenseType: string): string => licenseType.toLowerCase().replace(/\./gi, '-');
